/**
 * ErroIntegracao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'
import {Responsavel} from '@/model/resource/Responsavel'
import {ErroIntegracaoCollection} from '@/model/collection/ErroIntegracaoCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated class */
export class ErroIntegracao extends Resource {
  idErroPk: number = 0

  @ResponseSerialize(WebserviceIntegracao)
  webserviceIntegracao: WebserviceIntegracao | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  request: string | null = null
  response: string | null = null
  data: string | null = null
  idWebserviceFk: number | null = null

  danfe: string | null = null
  nf: string | null = null

  quant: number | null = null

  get $id() {
    return this.idErroPk
  }
  set $id(val) {
    this.idErroPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ErroIntegracao
   */
  async getErroIntegracao(id: number) {
    return await Request.get(`/admin/erro-integracao/${id}`)
      .name('getErroIntegracao')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ErroIntegracao
   */
  static async listErroIntegracao(params: any) {
    return await Request.get(`/admin/erro-integracao`, {params})
      .name('listErroIntegracao')
      .as(ErroIntegracaoCollection)
      .getData()
  }

  /**
   * Lists all responsaveis from ErroIntegracao
   */
  static async listResponsavel(params: any) {
    return await Request.get(`/admin/erro-integracao/responsavel`, {params})
      .name('listResponsavel')
      .as(ResponsavelCollection)
      .getData()
  }

  /**
   * Persists a new instance of ErroIntegracao. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistErroIntegracao() {
    return await Request.post(`/admin/erro-integracao`, this)
      .name('persistErroIntegracao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ErroIntegracao to use it in a CSV file
   */
  static async listCsvErroIntegracao(params: any) {
    return await Request.get(`/admin/erro-integracao/csv`, {params})
      .name('listCsvErroIntegracao')
      .as(ErroIntegracaoCollection)
      .getData()
  }
}
